/**
 * Debounce una función para que se ejecute después de que pase un tiempo sin llamadas
 * @param func - Función a debouncear
 * @param wait - Tiempo de espera en ms
 * @returns Función debounceada
 */
export function debounce<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeoutId: NodeJS.Timeout | null = null;

  return function (this: unknown, ...args: Parameters<T>) {
    // Limpiar el timeout anterior si existe
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    // Establecer un nuevo timeout
    timeoutId = setTimeout(() => {
      func.apply(this, args);
      timeoutId = null;
    }, wait);
  };
}
